import { render, staticRenderFns } from "./PowerForecast.vue?vue&type=template&id=523b18b2&scoped=true&"
import script from "./PowerForecast.vue?vue&type=script&lang=js&"
export * from "./PowerForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523b18b2",
  null
  
)

export default component.exports